import {Component, Input, OnInit} from '@angular/core';
import {Line} from "../../CardStruct";
import {VariableValue} from "../../../variableDataBase/VariableValue";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";

@Component({
  selector: 'app-line-button',
  templateUrl: './line-button.component.html',
  styleUrls: ['./line-button.component.css']
})
export class LineButtonComponent implements OnInit {
  @Input()
  line: Line = new Line();
  itemValue: &VariableValue = new VariableValue();

  constructor(private variableDB: VariableDataBase) {
  }

  ngOnInit(): void {
    this.itemValue = this.variableDB.AddValueByReference(this.line.variable.id);
  }

}
